import React from 'react'
import { connect } from 'react-redux'
import { TidewaysContext } from '../app/context'
import Navigator from '../app/navigator'
import { RangeSelectorInterface } from '../history/RangeSelectorInterface'
import { ApplicationState } from '../redux/ApplicationState'

interface TimeRangeOwnProps {
    rangeSelector: RangeSelectorInterface
}

interface TimeRangeStaticProps {
    tidewaysContext: TidewaysContext
    navigator: Navigator
}

type TimeRangeProps = TimeRangeOwnProps & TimeRangeStaticProps

interface TimeRangeLinkProps extends React.PropsWithChildren<object> {
    onClick: React.MouseEventHandler
    active: boolean
    disabled: boolean
    title: string
}

class TimeRangeLink extends React.Component<TimeRangeLinkProps> {
    public static defaultProps = {
        active: false,
        disabled: false,
        title: '',
    }

    public render = () => (
        <li className={this.classes().join(' ')} title={this.props.title}>
            <a onClick={this.props.onClick}>{this.props.children}</a>
        </li>
    )

    public classes = (): string[] => {
        const classes: string[] = []

        if (this.props.active) {
            classes.push('active')
        }

        if (this.props.disabled) {
            classes.push('disabled')
        }

        return classes
    }
}

class TimeRange extends React.Component<TimeRangeProps> {
    public render() {
        const { rangeSelector: selector } = this.props

        return (
            <React.Fragment>
                <ul className="nav nav-pills" style={{ float: 'right', textAlign: 'right', marginRight: 40 }}>
                    {selector.ranges.map(choice => (
                        <TimeRangeLink
                            key={choice.value}
                            onClick={() => selector.setDuration(choice.value)}
                            active={selector.active(choice.value)}
                            title={`change selected time span to ${choice.label}`}
                        >
                            {choice.label}
                        </TimeRangeLink>
                    ))}
                </ul>
                <ul className="nav nav-pills" style={{ float: 'right', textAlign: 'right', marginRight: 10 }}>
                    <TimeRangeLink title="move selected time portion to the left" onClick={() => selector.move('prev')}>
                        <i className="fa fa-caret-left" />
                    </TimeRangeLink>
                    <TimeRangeLink title="move selected time portion to the right" onClick={() => selector.move('next')}>
                        <i className="fa fa-caret-right" />
                    </TimeRangeLink>
                    <TimeRangeLink title="move to newest available data" onClick={() => selector.last()} disabled={selector.isLast()}>
                        <i className="fa fa-step-forward" />
                    </TimeRangeLink>
                </ul>
                {selector.supportsLiveData && selector.isLast() ? (
                    <ul className="nav nav-pills" style={{ float: 'right', marginRight: 10, border: 'none' }}>
                        <li title="data is updating automatically">
                            <span className="text-link">
                                live&nbsp;&nbsp;
                                <i className="fa fa-circle-thin fa-beat" />
                            </span>
                        </li>
                    </ul>
                ) : null}
            </React.Fragment>
        )
    }
}

export default connect<TimeRangeStaticProps, TimeRangeOwnProps>((globalState: ApplicationState, props: TimeRangeOwnProps) => ({
    tidewaysContext: globalState.tidewaysContext,
    navigator: new Navigator(globalState.tidewaysContext.route),
}))(TimeRange)
